import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { addToCart } from "../../../redux/features/cartState";

const CartModal = ({ item, onClose }) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(1);
  const totalPrice = count * item.price;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[50]"
      onClick={onClose}
    >
      <div
        className="relative p-8 bg-dry rounded-xl shadow-md max-w-lg m-2 z-[60] border border-border"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button className="absolute top-5 right-4 text-xl" onClick={onClose}>
          <XCircleIcon className="max-w-[24px] w-full text-text" />
        </button>

        {/* Modal Content */}
        <p className="text-lg sm:text-xl font-semibold text-red-500 mt-5">
          {item.title}
        </p>
        <p className="text-sm sm:text-sm text-text">{item.desc}</p>

        {/* Quantity Section */}
        <div className="flex items-center justify-between border border-gray-400 rounded px-2 py-1 my-5">
          <legend className="text-sm text-textGray">Quantity</legend>
          <p className="text-textGray">{count}</p>
          <div className="flex gap-1">
            <button
              className="border border-border rounded bg-border p-1"
              onClick={() => setCount(Math.max(count - 1, 1))}
            >
              -
            </button>
            <button
              className="border border-border rounded bg-border p-1"
              onClick={() => setCount(count + 1)}
            >
              +
            </button>
          </div>
        </div>

        {/* Total Price + Add */}
        <div className="flex justify-between items-center mt-2 p-2 border border-gray-400 rounded mt-5 min-w-[340px]">
          <legend className="text-sm text-textGray">Total</legend>
          <p className="ml-1 text-textGray">${totalPrice.toFixed(2)}</p>
          <button
            className="px-4 py-1 bg-red-500 rounded text-black hover:bg-gray-600 neon-black-box"
            onClick={() => {
              dispatch(addToCart({ item: { ...item, count } }));
              onClose(); // close modal after adding
            }}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartModal;
